import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-66de446b"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "You already have a tree with the same file name.", -1))
const _hoisted_2 = {
  key: 0,
  class: "match"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Do you want to continue?", -1))

import { computed, nextTick, ref } from 'vue'
import Modal from '@webapp/util/Modal.vue'
import WorkspaceSourcePanel from './WorkspaceSourcePanel.vue'
import { WorkspaceMatch } from './WorkspaceFinder.js'


export default /*#__PURE__*/_defineComponent({
  __name: 'WorkspaceMatchModal',
  props: {
    matches: {}
  },
  emits: ["update", "createNew", "cancel"],
  setup(__props: any, { expose: __expose, emit }) {

const props = __props;





const modalRef = ref<InstanceType<typeof Modal>>()
let decided = false

// Only the first match is shown -- same-name duplicates are rare, and one clear "you already have
// this" reads better than a list.
const firstMatchRef = computed(() => props.matches[0])

async function open() {
  decided = false
  // Wait for props to reflect the matches the caller just assigned before showing them.
  await nextTick()
  modalRef.value?.open()
}

function close() {
  modalRef.value?.close()
}

__expose({ open, close })

function onCreateNew() {
  decided = true
  emit('createNew')
  modalRef.value?.close()
}

async function onUpdateExisting() {
  if (!firstMatchRef.value) {
    return
  }
  decided = true
  // Fully hide the modal (and its backdrop) before the parent navigates away.
  await modalRef.value?.close()
  emit('update', firstMatchRef.value.workspaceId)
}

function onHidden() {
  // A dismiss with no choice made is a real cancel -- back out, don't create or update.
  if (!decided) {
    emit('cancel')
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    ref_key: "modalRef",
    ref: modalRef,
    onOk: onCreateNew,
    onHidden: onHidden
  }, {
    title: _withCtx(() => [
      _createTextVNode("Already uploaded?")
    ]),
    okText: _withCtx(() => [
      _createTextVNode("Create a new tree")
    ]),
    default: _withCtx(() => [
      _hoisted_1,
      (firstMatchRef.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(WorkspaceSourcePanel, {
              "workspace-id": firstMatchRef.value.workspaceId
            }, null, 8, ["workspace-id"]),
            _createElementVNode("button", {
              type: "button",
              class: "overlay",
              "aria-label": "View existing tree",
              onClick: onUpdateExisting
            })
          ]))
        : _createCommentVNode("", true),
      _hoisted_3
    ]),
    _: 1
  }, 512))
}
}

})